import { WithChildren, WithClassName } from "types";
import { useAccordionContext } from "../context/accordion.context";
import classNames from "classnames";
import styles from "./accordion.module.scss";

export interface AccordionProps extends WithChildren, WithClassName {
  id: string;
  isAbsolute?: boolean;
}

export const Accordion = ({
  id,
  children,
  className,
  isAbsolute,
}: AccordionProps) => {
  const { isOpen } = useAccordionContext();

  // if (!isOpen(id)) return null;

  return (
    <div
      className={classNames(
        styles.accordion,
        isOpen(id) && styles.open,
        isAbsolute && styles.absolute,
        className
      )}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
};
